/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vast_Sandy_Crab_LeapInputs */

const en_vast_sandy_crab_leap = /** @type {(inputs: Vast_Sandy_Crab_LeapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select file`)
};

const de_vast_sandy_crab_leap = /** @type {(inputs: Vast_Sandy_Crab_LeapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datei auswählen`)
};

/**
* | output |
* | --- |
* | "Select file" |
*
* @param {Vast_Sandy_Crab_LeapInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const vast_sandy_crab_leap = /** @type {((inputs?: Vast_Sandy_Crab_LeapInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vast_Sandy_Crab_LeapInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vast_sandy_crab_leap(inputs)
	return de_vast_sandy_crab_leap(inputs)
});